<div class="settings-shell">
    <header class="page-header">
        <p class="eyebrow">Settings</p>
        <h1>App Settings</h1>
        <p class="subtitle">Keep configuration screens in one consistent place instead of scattering admin pages across the app.</p>
    </header>

    <section class="settings-card">
        <div class="section-heading">
            <div>
                <h2>Configuration</h2>
                <p>Open the areas that control import behavior, templates, and business defaults.</p>
            </div>
        </div>

        <div class="settings-grid">
            <a class="settings-link-card" routerLink="/settings/bank-account-settings">
                <div class="icon-wrap">
                    <mat-icon>account_balance</mat-icon>
                </div>
                <div>
                    <h3>Bank Account Settings</h3>
                    <p>Manage imported accounts, sync flags, and GST defaults.</p>
                </div>
                <mat-icon class="chevron">arrow_forward</mat-icon>
            </a>

            <a class="settings-link-card" routerLink="/settings/item-template-editor/new">
                <div class="icon-wrap">
                    <mat-icon>inventory_2</mat-icon>
                </div>
                <div>
                    <h3>Item Template Editor</h3>
                    <p>Create and maintain reusable inventory item templates.</p>
                </div>
                <mat-icon class="chevron">arrow_forward</mat-icon>
            </a>
        </div>
    </section>

    <section class="settings-card">
        <div class="section-heading">
            <div>
                <h2>Bookkeeping</h2>
                <p>Control how far accounting views can navigate back in time.</p>
            </div>
        </div>

        <div class="settings-form-row">
            <mat-form-field appearance="outline">
                <mat-label>Bookkeeping start date</mat-label>
                <input matInput type="date" [(ngModel)]="bookkeepingStartDate" (change)="saveBookkeepingStartDate()">
                <mat-hint>Previous period navigation stops once this date is reached.</mat-hint>
            </mat-form-field>
        </div>
    </section>
</div>
